import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Kolibrio apenaŭ pli grandas ol abelo; sed ŝi tamen estas birdo!
    </p>
    
    <p class="mb-3">
      - Niaj agloj estas tiaj bravuloj! – ŝatas ripeti ŝi. Simple, por ajna okazo.
    </p>
    `
  )
}

const itemName = {
  esp: 'La digno'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;